import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { notification } from 'antd';
import { login } from '../../actions/fetch';

const useLogin = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const onError = (e) => {
    const { msg } = JSON.parse(e.body);

    notification.error({
      message: t('error'),
      description: msg,
    });
  };

  const handleSubmit = (values) => dispatch(login(values, { onError }));

  return {
    onSubmit: handleSubmit,
  };
};

export default useLogin;
